import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import ourStoryPost from '../../../assets/images/jpg/about-us/our-story.jpg';
import StarredImage from '../../home/components/StarredImage';

interface OurStoryDataTypes {
  title: string;
  paragraphs: string[];
  image: string;
  footerText: string;
}

const OurStory = () => {
  const ourStoryData: OurStoryDataTypes = {
    title: 'Legalligence was built to meet that need.',
    paragraphs: [
      'Our AI-powered platform is designed to simplify and streamline legal workflows— enabling corporates to manage risk more efficiently, helping legal professionals work smarter, and making legal support more accessible to individuals. But while technology is at our core, human judgment remains at the heart of everything we do.',
      'We work closely with top legal consultants from across India who guide us as domain advisors.Their real-world experience ensures our tools are not only innovative but also practical, compliant, and aligned with the complexities of law as it’s practiced today.',
    ],
    image: ourStoryPost,
    footerText:
      'Our goal is simple: to provide smart, efficient solutions that minimize time spent on routine work and empower legal professionals to focus on what truly matters—thinking, advising, and leading.',
  };

  const { title, paragraphs, image, footerText } = ourStoryData;
  return (
    <section className="section-gap-lg">
      <Container>
        <div className="ourstory-container">
          <Row className="g-5 g-md-5 g-lg-0">
            <Col lg="5" md="12">
              <div className="ourstory-cnt" data-aos="fade-right">
                <h2>{title}</h2>
                <p className="head-gap-lg">{paragraphs[0]}</p>
                <p>{paragraphs[1]}</p>
              </div>
            </Col>
            <Col lg="7" md="12">
              <div className="our-story-img-cnt" data-aos="fade-left">
                <div className="our-story-img">
                  <StarredImage
                    imageSrc={image}
                    alt={title || 'Legalligence was built to meet that need.'}
                    starPosition="right"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default OurStory;
